<script>
import AccountNav from '@components/admin/account-nav'
import AccountInfo from '@components/admin/account-info'
import AdminLayout from '@layouts/admin-main'

export default {
  page: {
    title: 'Admin::AccountView',
    meta: [{ name: 'description', content: 'Admin::AccountView' }],
  },
  components: { AdminLayout, AccountNav, AccountInfo },
}
</script>

<template>
  <AdminLayout>
    <AccountNav></AccountNav>
    <AccountInfo :account_seq="$route.params.account_seq"></AccountInfo>
  </AdminLayout>
</template>
